import WEBROOM from '../../store/WebRoom';
import store from '../../store/store';
import {
  _change_ds_modal,
  _open_my_center,
  _new_room_window,
  _dssp_show_event,
} from '../../store/Action';

window.childIframeEvents = (data) => {
  iframeElementCallback({}, data, true);
};

const iframeElementCallback = (props, msg, iframeElement, callback = null) => {
  const base = store.getState();
  const { history } = props;
  const { roomid, conn } = WEBROOM;
  if (msg.data?.key) {
    let value = null;
    switch (msg.data.key) {
      case 'getUserInfo':
        value = {
          reallySource: base.rootConfig.source,
        };
        if (base.userInfo) {
          const user = base.userInfo;
          value.uid = user.uid;
          value.token = user.accessToken;
          value.nickname = user.nickname;
          value.avatar = user.avatar;
          value.sex = user.sex;
          value.roomId = conn ? roomid : null;
        }
        break;
      case 'joinRoomById':
        const paraRoomid = msg.data.value;
        _new_room_window({ roomid: paraRoomid.roomId }, history, () => {
          callback && callback();
        });
        break;

      case 'back-home':
        // 返回首页
        this.props.history.push(`/index${window.location.search}`);
        break;
      case 'redirectStarHousePage':
        //打开星愿屋
        if (base?.userInfo?.uid) {
          _open_my_center({
            dsid: base.userInfo.uid,
            tab: 'tab16',
          });
          callback && callback();
        }
        break;
      case 'showMatchUser':
        // 打开用户主页
        if (msg.data?.value?.uid) {
          _change_ds_modal({
            dsid: msg.data?.value?.uid,
            jnid: msg.data?.value?.categoryId || null,
            ehot: false,
            isOpenDetail: msg.data?.value?.isOpenDetail || false,
          });

          callback && callback();
        }
        break;
      case 'vcGoBack':
      case 'vcClosePopup':
        // 关闭弹窗
        callback && callback();
        break;
      case 'xiuxian_getUserInfo':
        value = {
          reallySource: base.rootConfig.source,
        };
        if (base.userInfo) {
          const user = base.userInfo;
          value.uid = user.uid;
          value.token = user.accessToken;
          value.nickname = user.nickname;
          value.avatar = user.avatar;
          value.sex = user.sex;
          value.roomId = conn ? roomid : null;
        }
        break;
      case 'xiuxian_isHost':
        value = {
          reallySource: base.rootConfig.source,
        };
        if (base.userInfo) {
          value.isHost = WEBROOM.isMaster();
        }
        break;
      case 'xiuxian_getAppRoomID':
        value = {
          reallySource: base.rootConfig.source,
        };
        if (base.userInfo) {
          value.roomid = conn ? roomid : null;
        }
        break;
      case 'xiuxian_changePartyRoom':
        const data = msg.data?.value;
        _new_room_window({ roomid: data.roomId }, history, () => {
          callback && callback();
        });
        break;
      case 'dssp_show_event':
        const params = msg.data.value;
        if (params != null && typeof params == 'object') {
          params.scene_category = '非房间内';
          if (WEBROOM.conn) {
            params.scene_category = '房间内';
            if (
              params?.scene_value != null &&
              typeof params?.scene_value === 'object' &&
              params?.scene_value &&
              !params?.scene_value?.room_id
            ) {
              params.scene_value.room_id = WEBROOM.roomid;
            }
          }

          _dssp_show_event(params);
        }
        break;
      default:
        break;
    }
    if (!!value && iframeElement) {
      if (iframeElement?.contentWindow?.postMessage) {
        iframeElement.contentWindow.postMessage(
          {
            key: msg.data.callback,
            value,
          },
          '*'
        );
      }

      if (
        window.ElectronChildWebView &&
        window?.ddElectron?.childIframePostMessage
      ) {
        window.ddElectron.childIframePostMessage({
          key: msg.data.callback,
          value,
        });
      }
    }
  }
};

export default iframeElementCallback;
